// import React from "react";
// import {
//   Form,
//   Input,
//   DatePicker,
//   Select,
//   Card,
//   Row,
//   Col,
//   Button,
//   Space,
// } from "antd";
// import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
// import Accordion from "react-bootstrap/Accordion";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "./Siblings.css";

// const { Option } = Select;

// const Siblings = ({ onSiblingDataChange }) => {
//   const [form] = Form.useForm();

//   const onFormChange = () => {
//     const siblingData = form.getFieldsValue();
//     onSiblingDataChange(siblingData); // Send sibling data back to parent component
//   };

//   return (
//     <div className="siblings-container">
//       <Accordion>
//         <Accordion.Item eventKey="0">
//           <Accordion.Header>Siblings Details</Accordion.Header>
//           <Accordion.Body>
//             <Form
//               form={form}
//               layout="vertical"
//               name="siblingsForm"
//               initialValues={{ siblings: [{}] }} // Initialize with one sibling
//               onValuesChange={onFormChange} // Trigger on form change
//             >
//               <Form.List name="siblings">
//                 {(fields, { add, remove }) => (
//                   <>
//                     {fields.map(({ key, name, ...restField }) => (
//                       <Space
//                         key={key}
//                         style={{
//                           display: "block",
//                           marginBottom: 24,
//                         }}
//                         align="baseline"
//                       >
//                         <Card
//                           title={`Sibling ${key + 1}`}
//                           bordered={false}
//                           className="siblings-card"
//                           extra={
//                             fields.length > 1 && (
//                               <MinusCircleOutlined
//                                 onClick={() => remove(name)}
//                               />
//                             )
//                           }
//                         >
//                           <Row gutter={16}>
//                             <Col xs={24} sm={12}>
//                               <Form.Item
//                                 {...restField}
//                                 label="Name"
//                                 name={[name, "siblingName"]}
//                               >
//                                 <Input placeholder="Enter name" />
//                               </Form.Item>
//                             </Col>
//                             <Col xs={24} sm={12}>
//                               <Form.Item
//                                 {...restField}
//                                 label="Sex"
//                                 name={[name, "siblingSex"]}
//                               >
//                                 <Select placeholder="Select sex">
//                                   <Option value="MALE">MALE</Option>
//                                   <Option value="FEMALE">FEMALE</Option>
//                                   <Option value="OTHERS">OTHERS</Option>
//                                 </Select>
//                               </Form.Item>
//                             </Col>
//                             <Col xs={24} sm={12}>
//                               <Form.Item
//                                 {...restField}
//                                 label="Date of Birth"
//                                 name={[name, "siblingDOB"]}
//                               >
//                                 <DatePicker
//                                   placeholder="Select DOB"
//                                   format="DD-MM-YYYY"
//                                   style={{ width: "100%" }}
//                                 />
//                               </Form.Item>
//                             </Col>
//                             <Col xs={24} sm={12}>
//                               <Form.Item
//                                 {...restField}
//                                 label="Relation"
//                                 name={[name, "siblingRelation"]}
//                               >
//                                 <Input placeholder="Enter relation" />
//                               </Form.Item>
//                             </Col>
//                           </Row>
//                         </Card>
//                       </Space>
//                     ))}
//                     <Form.Item>
//                       <Button
//                         type="dashed"
//                         onClick={() => add()}
//                         block
//                         icon={<PlusOutlined />}
//                       >
//                         Add Sibling
//                       </Button>
//                     </Form.Item>
//                   </>
//                 )}
//               </Form.List>
//             </Form>
//           </Accordion.Body>
//         </Accordion.Item>
//       </Accordion>
//     </div>
//   );
// };

// export default Siblings;

import React from "react";
import {
  Form,
  Input,
  DatePicker,
  Select,
  Card,
  Row,
  Col,
  Button,
  Space,
} from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import Accordion from "react-bootstrap/Accordion";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Siblings.css";

const { Option } = Select;

const Siblings = ({ onSiblingDataChange }) => {
  const [form] = Form.useForm();

  const onFormChange = () => {
    const siblingData = form.getFieldsValue();
    onSiblingDataChange(siblingData); // Send sibling data back to parent component
  };

  return (
    <div className="siblings-container">
      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header>Siblings Details</Accordion.Header>
          <Accordion.Body>
            <Form
              form={form}
              layout="vertical"
              name="siblingsForm"
              initialValues={{ siblings: [{}] }} // Initialize with one sibling
              onValuesChange={onFormChange} // Trigger on form change
            >
              <Form.List name="siblings">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <Space
                        key={key}
                        style={{
                          display: "block",
                          marginBottom: 24,
                        }}
                        align="baseline"
                      >
                        <Card
                          title={`Sibling ${key + 1}`}
                          bordered={false}
                          className="siblings-card"
                          extra={
                            fields.length > 1 && (
                              <MinusCircleOutlined
                                onClick={() => remove(name)}
                              />
                            )
                          }
                        >
                          <Row gutter={16}>
                            <Col xs={24} sm={12}>
                              <Form.Item
                                {...restField}
                                label="Name"
                                name={[name, "siblingName"]}
                              >
                                <Input placeholder="Enter name" />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12}>
                              <Form.Item
                                {...restField}
                                label="Sex"
                                name={[name, "siblingSex"]}
                              >
                                <Select placeholder="Select sex">
                                  <Option value="MALE">MALE</Option>
                                  <Option value="FEMALE">FEMALE</Option>
                                  <Option value="OTHERS">OTHERS</Option>
                                </Select>
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12}>
                              <Form.Item
                                {...restField}
                                label="Date of Birth"
                                name={[name, "siblingDOB"]}
                              >
                                <DatePicker
                                  placeholder="Select DOB"
                                  format="DD-MM-YYYY"
                                  style={{ width: "100%" }}
                                  inputReadOnly={false}
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12}>
                              <Form.Item
                                {...restField}
                                label="Relation"
                                name={[name, "siblingRelation"]}
                              >
                                <Select placeholder="Select relation">
                                  <Option value="youngerBrother">
                                    Younger Brother
                                  </Option>
                                  <Option value="elderBrother">
                                    Elder Brother
                                  </Option>
                                  <Option value="youngerSister">
                                    Younger Sister
                                  </Option>
                                  <Option value="elderSister">
                                    Elder Sister
                                  </Option>
                                </Select>
                              </Form.Item>
                            </Col>

                            {/* New Fields
                            <Col xs={24} sm={12}>
                              <Form.Item
                                {...restField}
                                label="Mobile Number"
                                name={[name, "siblingMobileNo"]}
                                rules={[
                                  {
                                    pattern: /^\d{10}$/,
                                    message:
                                      "Mobile number must be exactly 10 digits",
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Enter mobile number"
                                  maxLength={10}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    // Only allow numeric input and max length of 10
                                    if (
                                      /^\d*$/.test(value) &&
                                      value.length <= 10
                                    ) {
                                      e.target.value = value;
                                    }
                                  }}
                                />
                              </Form.Item>
                            </Col>

                            <Col xs={24} sm={12}>
                              <Form.Item
                                {...restField}
                                label="Aadhar Number"
                                name={[name, "siblingAadharno"]}
                                rules={[
                                  {
                                    pattern: /^\d{12}$/,
                                    message:
                                      "Aadhar number must be exactly 12 digits",
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Enter Aadhar number"
                                  maxLength={12}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    // Only allow numeric input and max length of 12
                                    if (
                                      /^\d*$/.test(value) &&
                                      value.length <= 12
                                    ) {
                                      e.target.value = value;
                                    }
                                  }}
                                />
                              </Form.Item>
                            </Col>

                            <Col xs={24} sm={12}>
                              <Form.Item
                                {...restField}
                                label="ABHA Number"
                                name={[name, "siblingAbhaid"]}
                                rules={[
                                  {
                                    pattern: /^\d{14}$/,
                                    message:
                                      "ABHA number must be exactly 14 digits",
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Enter ABHA number"
                                  maxLength={14}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    // Only allow numeric input and max length of 14
                                    if (
                                      /^\d*$/.test(value) &&
                                      value.length <= 14
                                    ) {
                                      e.target.value = value;
                                    }
                                  }}
                                />
                              </Form.Item>
                            </Col> */}
                          </Row>
                        </Card>
                      </Space>
                    ))}
                    <Form.Item>
                      <Button
                        type="dashed"
                        onClick={() => add()}
                        block
                        icon={<PlusOutlined />}
                      >
                        Add Sibling
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
            </Form>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default Siblings;
